





















import Vue from "vue";
import { Period } from "../../interfaces/Period";
import { RunRef } from "../../interfaces/RunRef";
export default Vue.extend({
  props: {
    periods: {
      type: Array as () => Period[],
      required: false,
    },
    value: {
      type: Object as () => RunRef,
      required: false,
    },
  },
  computed: {
    currentRun: {
      get(): any {
        return this.value?.nr;
      },
      set(run: string) {
        this.$emit("input", Object.assign({}, this.value, { nr: run }));
      },
    },
    currentPeriod: {
      get(): any {
        return this.value?.of?.code;
      },
      set(periodCode: string) {
        const period: Period | undefined = this.periods.find(period => {
          return period.code == periodCode;
        });
        this.$emit(
          "input",
          Object.assign({}, this.value, {
            nr: period?.runs ? period?.runs[period?.runs.length - 1].nr : undefined,
            of: { code: periodCode },
          })
        );
      },
    },
    getPeriods(): any {
      return this.periods?.map(period => {
        return period?.code;
      });
    },
    getRuns(): any {
      return this.periods
        .find(period => {
          return period.code == this.currentPeriod;
        })
        ?.runs?.map(run => {
          return run.nr;
        });
    },
  },
});
